import * as React from 'react'

export const IndividualRewards = process.env.LOCALE === "es-EC" ? [
  {
    title: '',
    description: <>1 ganadora de Iphone XR y 4 ganadoras de 6 meses de productos Nosotras.</>,
    winnersNumber: '5 GANADORAS',
  },
]
: process.env.LOCALE === "es-PE" ? [
  {
    title: '',
    description: <>Serán 2 ganadoras de una espectacular tablet Lenovo P11 Snapdragon de 128GB y 6GB RAM + Slate Grey + Keyboard Pack y Precisión Pen 2</>,
    winnersNumber: '2 GANADORAS',
  },
]
:
[
  {
    title: 'Etapa 1:',
    description: <>1 Iphone y 4 kits con productos Nosotras por 6 meses.</>,
    winnersNumber: '5 GANADORAS',
  },
  {
    title: 'Etapa 2:',
    description: <>1 Iphone y 4 kits con productos Nosotras por 6 meses.</>,
    winnersNumber: '5 GANADORAS',
  },
  {
    title: 'Etapa 3:',
    description: <>1 Iphone y 4 kits con productos Nosotras por 6 meses.</>,
    winnersNumber: '5 GANADORAS',
  },
]

export const CollegeReward = process.env.LOCALE === "es-EC" ? [
  {
    title: '',
    description: <>1 ganadora de Iphone 13 y 4 ganadoras de 6 meses de productos Nosotras.</>,
    winnersNumber: '5 GANADORAS',
  },
]
: process.env.LOCALE === "es-PE" ? [
  {
    title: '',
    description: <>Una fiesta de promoción para los chicos de quinto de media.</>,
    winnersNumber: '1 COLEGIO GANADOR',
  },
]
:
[
  {
    title: 'Etapa 4',
    description: (
      <>
        <b>Una fiesta para tu colegio</b> con DJ, rifas, juegos y mucho más.
      </>
    ),
    winnersNumber: '1 COLEGIO GANADOR',
  },
]
